import { Button } from '@chakra-ui/react';
import { usePopup } from 'context/PopupContext/PopupContext';
import React from 'react';

interface ClipboardButtonProps {
  textToCopy: string;
  buttonText?: string;
}

const ClipboardButton: React.FC<ClipboardButtonProps> = ({ textToCopy, buttonText }) => {
  const { showPopup } = usePopup();
  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      showPopup({
        message: `${text} successfully copied to clipboard.`,
        type: 'SUCCESS',
      });
    } catch (error) {
      showPopup({
        message: `Failed to copy text. Please try again.`,
        type: 'ERROR',
      });
    }
  };

  return (
    <Button
      bg={'yellow'}
      color={'black'}
      border={'2px solid black'}
      onClick={() => copyToClipboard(textToCopy)}
    >
      {buttonText}
    </Button>
  );
};

export default ClipboardButton;
